import {useState} from 'react'
import {storage} from '../../../../../services/firebase'
import db from '../../../../../services/firebase'
import {ref, uploadBytesResumable, getDownloadURL} from 'firebase/storage'
import {addDoc, collection, updateDoc} from 'firebase/firestore'
import {useAuth} from '../../../../modules/auth'
import {showErrorToast, showSuccessToast} from 'app/components/ShowToast'
import Button from 'app/components/Button'

const DataRoomToolbar = ({
  onHeaderAction,
  subFolderClicked,
  folderPath,
  folderId,
  fileFolderCreated,
  currentAuditContext,
}) => {
  const [isUploading, setIsUploading] = useState(false)
  const {currentUser} = useAuth()

  const handleChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const f = e.target.files[0]
      if (f) {
        handleUpload(f)
      }
    }
  }
  const handleCustomUpload = () => {
    const hiddenFileInput: HTMLElement | null = document.getElementById('hiddenFileInput')
    hiddenFileInput?.click()
  }

  const handleUpload = async (file: File) => {
    if (file || folderId) {
      const storageRef = ref(storage, `${folderPath}/${file.name}`)
      const uploadTask = uploadBytesResumable(storageRef, file)
      setIsUploading(true)
      uploadTask.on(
        'state_changed',
        (snapshot) => {},
        (error) => {
          setIsUploading(false)
        },
        async () => {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref)
          const currentDate = new Date()
          const year = currentDate.getFullYear()
          const month = String(currentDate.getMonth() + 1).padStart(2, '0')
          const day = String(currentDate.getDate()).padStart(2, '0')

          const formattedDate = `${year}-${month}-${day}`
          const tenantId = currentUser?.tenantId || ''
          const fileCollectionRef = collection(db, 'tenants', tenantId, 'dataroom')
          const newFile = {
            subFolder: `${folderPath}${file.name}`,
            parentFolder: folderId ? folderId : '',
            name: file.name,
            fileSize: file.size,
            contentType: file.type,
            downloadUrl: downloadURL,
            uploadedBy: currentUser?.userName,
            time_created: formattedDate,
            tenantId: currentUser?.tenantId,
            uid: currentUser?.uid,
            is_folder: false,
          }
          const newDocRef = await addDoc(fileCollectionRef, newFile)
          if (folderPath === `/tenants/${currentUser?.tenantId}/dataroom/`) {
            await updateDoc(newDocRef, {fileId: newDocRef.id, is_file: true})
          } else {
            await updateDoc(newDocRef, {fileId: newDocRef.id})
          }
          await updateDoc(newDocRef, {fileId: newDocRef.id})
          showSuccessToast({message: 'File uploaded successfully'})

          fileFolderCreated(true)
          setIsUploading(false)
        }
      )
    } else {
      showErrorToast({message: 'Please select a file first.'})
    }
  }

  if (currentUser?.role === 'Auditor' || currentAuditContext) {
    return null
  }

  return (
    <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
      {!folderId ? (
        <Button className='me-4' onClick={onHeaderAction}>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='18'
            height='18'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            stroke-width='2'
            stroke-linecap='round'
            stroke-linejoin='round'
            className='icon icon-tabler icons-tabler-outline icon-tabler-plus me-2'
          >
            <path stroke='none' d='M0 0h24v24H0z' fill='none' />
            <path d='M12 5l0 14' />
            <path d='M5 12l14 0' />
          </svg>
          New Folder
        </Button>
      ) : (
        <div></div>
      )}
      <input
        type='file'
        id='hiddenFileInput'
        onChange={handleChange}
        accept='.docx,.pdf,.jpg,.png,.xlsx,.csv'
        style={{display: 'none'}}
      />
      <Button btnType='primary' disabled={isUploading} onClick={handleCustomUpload}>
        {isUploading ? (
          <>
            Uploading... <span className='spinner-border spinner-border-sm align-middle'></span>
          </>
        ) : (
          'Upload'
        )}
      </Button>
    </div>
  )
}
export {DataRoomToolbar}
